import {defineCustomElement} from 'extensions/utils';
import stylesheet from './x-swatch.component.scss?as=stylesheet';
import {html, nothing, LitElement} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import {styleMap} from 'lit/directives/style-map.js';

export class Swatch extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			checked: {
				type: Boolean
			},
			color: {
				type: String
			},
			image: {
				type: String
			},
			label: {
				type: String
			}
		};
	}

	constructor () {
		super();

		this.checked = false;
		this.color = '';
		this.image = '';
		this.label = '';
	}

	handleChange () {
		this.dispatchEvent(new CustomEvent('change'));
	}

	renderSwatchOrImage () {
		if (this.image) {
			return html`<div class="image">
				<img src="${this.image}" aria-hidden="true" loading="lazy" />
			</div>`;
		}
		else if (this.color) {
			const styles = {
				background: this.color
			};

			return html`<div class="swatch" style="${styleMap(styles)}"></div>`;
		}

		return nothing;
	}

	render () {
		const classes = {
			'is--checked': this.checked
		};

		return html`<button class="${classMap(classes)}" @click="${this.handleChange}">
			${this.renderSwatchOrImage()}
			<span class="label">${this.label}</span>
		</button>`;
	}
};

defineCustomElement('x-swatch', Swatch);
